import { AxiosPromise } from "axios";
import { IBugReportPayload } from "./types";
import Http from "../../../common/http/createHttp";

export function sendBugReport(
  bugReportPayload: IBugReportPayload
): AxiosPromise {
  return Http.postPdf("/pdf/bug-report", bugReportPayload);
}
